/**
 * Labstep
 *
 * @module core/Hoverable
 * @desc A component that renders a react element based on hovering another element
 */

import classnames from 'classnames';
import type React from 'react';
import styles from './styles.module.scss';
import type { IHoverableProps } from './types';

export const Hoverable: React.FC<IHoverableProps> = ({
  component,
  hoverable,
  className,
  show,
  dataTestId = '',
}) => (
  <div
    data-testid={dataTestId}
    className={classnames(styles.container, className)}
  >
    {hoverable}
    <div className={show ? undefined : 'to-appear'}>{component}</div>
  </div>
);
